import SendGridService from './SendGridService';
import moment from 'moment';

class TrialMailService {
  constructor({
    user,
    accountId,
    universeId,
    dashboardsQuantity,
  }) {
    this.user = user;
    this.accountId = accountId;
    this.universeId = universeId;
    this.dashboardsQuantity = dashboardsQuantity;
  }

  send() {
    this.params = {
      'subject': 'Studio - Solicitação de proposta',
      'fromEmail': {
        'name': 'Milena Alvarez',
        'email': 'milena.alves@stilingue.com.br',
      },
      'toEmails': [
        {
          'email': process.env.VUE_APP_STUDIO_TRIAL_RECIPIENT_EMAIL,
        },
      ],
      'data': {
        'date': moment().format('llll'),
        'title': 'Studio - Solicitação de proposta',
        'paragraph1': `Usuário: ${this.user.name} / Email:${this.user.email}`,
        'paragraph2': `Cliente: ${this.user.user_group || this.user.userGroup}`,
        'paragraph3': `Id da Conta: ${this.accountId} / Id da Pesquisa: ${this.universeId}`,
        'paragraph4': `De quantos dashboards precisa: ${this.dashboardsQuantity}`,
      },
    };

    SendGridService.sendMail(this.params);
  }
}
export default TrialMailService;
